import * as types from '../constants/ActionTypes';

const initialState = {
    level: 'success',
    message: null
};

export default function userNotification(state = initialState, action) {
    const { type } = action;
    switch (type) {
        case types.CLEAR_USER_NOTIFICATION:
            return initialState;
        case types.SAVE_HOMEWORK_SUCCESS:
        case types.UPDATE_HOMEWORK_SUCCESS:
            return {
                level: 'success',
                message: 'Verifica salvata correttamente'
            };
        case types.UPDATE_EXERCISE_SUCCESS:
        case types.SAVE_EXERCISE_SUCCESS:
            return {
                level: 'success',
                message: 'Esercizio salvato correttamente'
            };
        default:
            return state;
    }
}
